<div mat-dialog-title class="m-0">
    ส่งต่อแบบทดสอบ
    <div style="float: right; margin-top: -5px;">

        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()"
            style="float: right; margin-top: -6px;">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>


<mat-dialog-content id="modalMeasureReport" class="mat-typography">
    <div *ngIf="!isShare" class="container pt-3">
        <h5 class="text-center">กรุณากรอกอีเมล</h5>
        <form [formGroup]="shareMeasureForm">
            <div class="form-group row d-flex justify-content-center">
                <input (input)="isError = false" type="email" class="form-control col-lg-8 col-md-12 col-sm-12 col-12" formControlName="EMAIL"
                    id="email" style="width: 333px; max-width: 100%;">
            </div>
            <div *ngIf="isError" class="d-flex justify-content-center">
                <p class="text-danger">
                    {{ errMsg }}
                </p>
            </div>
        </form>
    </div>
    <div *ngIf="isShare" class="container py-3">
        <h5 class="text-center">แชร์สำเร็จแล้ว</h5>
        <img src="../../../assets/check.png" width="100px;" class="img-center">
    </div>
</mat-dialog-content>

<div *ngIf="!isShare" align="center" style="padding-bottom: 20px;">
    <button mat-button class="mb-1" style="background: #3E8C1A; color: #fff;" [disabled]="!shareMeasureForm.valid"
        (click)="send(shareMeasureForm.value)">
        ส่ง
    </button>
</div>

<div *ngIf="isShare" align="center" style="padding-bottom: 20px;">
    <button mat-button class="mb-1" style="background: #3E8C1A; color: #fff;" (click)="isShare = false">
        แชร์เพิ่ม
    </button>
</div>